import { assign } from 'lodash';

export const formatAsForm = (myProfile: Nl.Api.MyProfile) => ({
  name: myProfile.name,
  legal_name: myProfile.legal_name,
  contact_information: assign({}, myProfile.contact_information, {
    country_uuid: myProfile?.contact_information?.country?.uuid,
  }),
});
